import React, { useState, useEffect } from "react";
import { Link, useLocation, useMatch } from "react-router-dom";

import logo from "../assets/img/logo/logo.png";

export default function Main() {
  const homeNavActive = useMatch("/");
  const aboutNavActive = useMatch("/about");
  const roomNavActive = useMatch("/rooms");
  const serviceDetailsNavActive = useMatch("/attractions");
  const galleryNavActive = useMatch("/gallery");
  const teamDetailsNavActive = useMatch("/team-details");
  const contactNavActive = useMatch("/contact");

  const location = useLocation();
  const path = location.pathname;

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    window.scroll(0, 0);
  }, [path]);

  useEffect(() => {}, []);

  return (
    <header className="menu-area">
      <div className="container">
        <div className="row align-items-center justify-content-between justify-content-md-evenly second-menu align-items-stretch">
          <div className="col-auto d-flex justify-content-center align-items-center pl-md-0 pr-md-0">
            {homeNavActive ? (
              <img
                src={logo}
                alt="logo"
                style={{
                  height: "auto",
                  minWidth: "58px",
                  maxWidth: "min(110px,5.8vw)",
                  opacity: checked ? "0" : "1",
                  visibility: checked ? "hidden" : "visible",
                }}
              />
            ) : (
              <Link
                to="/"
                style={{
                  height: "auto",
                  minWidth: "58px",
                  maxWidth: "min(110px,5.8vw)",
                  opacity: checked ? "0" : "1",
                  visibility: checked ? "hidden" : "visible",
                }}
              >
                <img src={logo} alt="logo" />
              </Link>
            )}
          </div>
          <div className="col-auto menu-toggle-container">
            <input
              id="menu-toggle"
              type="checkbox"
              checked={checked}
              onChange={() => setChecked(!checked)}
            />
            <label className="menu-button-container" htmlFor="menu-toggle">
              <div className="menu-button"></div>
            </label>
          </div>
          <div className="col-md-11 col-xxl-10 menu-list-container main-menu text-center">
            <nav style={{ height: "100%" }}>
              <ul
                className={`menu-list ${checked ? "" : "not-checked"}`}
                style={{ height: "100%" }}
              >
                <li className={homeNavActive ? "active" : ""}>
                  <Link
                    to="/"
                    style={{ whiteSpace: "nowrap" }}
                    onClick={() => setChecked(false)}
                  >
                    Strona główna
                  </Link>
                </li>
                <li className={aboutNavActive ? "active" : ""}>
                  <Link
                    to="/about"
                    style={{ whiteSpace: "nowrap" }}
                    onClick={() => setChecked(false)}
                  >
                    O nas
                  </Link>
                </li>
                <li className={roomNavActive ? "active" : ""}>
                  <Link
                    to="/rooms"
                    style={{ whiteSpace: "nowrap" }}
                    onClick={() => setChecked(false)}
                  >
                    Pokoje i serwis
                  </Link>
                </li>
                <li className={serviceDetailsNavActive ? "active" : ""}>
                  <Link to="/attractions" onClick={() => setChecked(false)}>
                    Atrakcje
                  </Link>
                </li>
                <li className={galleryNavActive ? "active" : ""}>
                  <Link to="/gallery" onClick={() => setChecked(false)}>
                    Galeria
                  </Link>
                </li>
                <li className={teamDetailsNavActive ? "active" : ""}>
                  <Link to="/team-details" onClick={() => setChecked(false)}>
                    Zespół
                  </Link>
                </li>
                <li className={contactNavActive ? "active" : ""}>
                  <Link to="/contact" onClick={() => setChecked(false)}>
                    Kontakt
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
}
